import { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';
import { COUNTRY } from '../../constants';

export default Yup.object().shape({
  email: Yup.string()
    .required('Il campo è obbligatorio')
    .email('Formato dell\'email non valido'),
  name: Yup.string()
    .required('Il campo è obbligatorio'),
  phoneNumber: Yup.string()
    .optional()
    .test('isValid', 'Formato del telefono non valido', (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY)),
});
